import React from 'react'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import useModals from 'src/Hooks/useModals'
import { useTypedSelector } from 'src/State/RootReducer'
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useEffectShopAccess, useShopAdmin, useShopCart } from '../../hooks'
import { useDispatch } from 'react-redux'
import { updateShopBasketQuantity } from 'src/State/Shop/ShopAction'
import { Search } from '../Search'
import { useLocation } from 'react-router-dom'
import { useShopCartContext } from '../../context'

const useStyles = makeStyles()(theme => ({
  basketContainer: {
    position: 'relative',
  },
  quantityContainer: {
    top: '-6px',
    right: '-4px',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '22px',
    height: '22px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    zIndex: 1,
    paddingTop: '2px',
  },
  quantity: {
    color: theme.palette.primary.contrastText,
    fontWeight: '500',
  },
}))

const BASKET_MINIMUM_QUANTITY = 1

/*
 * This component shows shop basket icon and opens the sidebar drawer of cart.
 */
const ShopBasket: React.FC = () => {
  const { classes } = useStyles()
  const { checkIsShopUserAdmin } = useShopAdmin()
  const { breakpoints } = useTheme()
  const shopAccess = useTypedSelector(state => state.shop.shopAccess)
  const basketQuantity = useTypedSelector(state => state.shop.basketQuantity)
  const selectedUserShopToken = useTypedSelector(state => state.shop.selectedUserData?.contextToken)
  const isShopAdmin = checkIsShopUserAdmin()
  const { openShopCheckoutSideBar } = useModals()
  const hasProducts = basketQuantity >= BASKET_MINIMUM_QUANTITY
  const { getCheckoutProducts } = useShopCart()
  const hasBasketAccess = (!isShopAdmin && shopAccess) || (isShopAdmin && shopAccess && selectedUserShopToken)
  const location = useLocation()
  const isDownSm = useMediaQuery(breakpoints.down('sm'))
  const isShopLocation = location.pathname.startsWith('/shop')
  const isSearchHidden = !isShopLocation
  const isBasketHidden = !isShopLocation && isDownSm
  const hasQuantity = hasProducts && !isBasketHidden
  const dispatch = useDispatch()
  const { setCartData } = useShopCartContext()

  useEffectShopAccess(() => {
    getCheckoutProducts()
      .then(result => {
        const basketItemsQuantity = result?.lineItems.length ?? 0
        dispatch(updateShopBasketQuantity(basketItemsQuantity))
        setCartData(result)
      })
      .catch(error => console.log(error))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUserShopToken])

  if (hasBasketAccess) {
    return (
      <Box className={classes.basketContainer}>
        {hasQuantity && (
          <Box className={classes.quantityContainer}>
            <Typography typography="body2" className={classes.quantity}>
              {basketQuantity}
            </Typography>
          </Box>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {!isSearchHidden && <Search />}
          {!isBasketHidden && (
            <IconButton color="inherit" onClick={openShopCheckoutSideBar}>
              <ShoppingCartOutlinedIcon />
            </IconButton>
          )}
        </Box>
      </Box>
    )
  }
  return null
}

export default ShopBasket
